export default {
	environment: process.env.REACT_APP_ENVIRONMENT,
	url: process.env.REACT_APP_URL,
};
